import { sendSumoLog } from './sumoLogger';
export const fetchMatchingTickets = async (ticketString, token, dispatch) => {
  const requestURL = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket/${ticketString}`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });
  try {
    const data = await fetch(requestURL, {
      method: 'GET',
      headers,
    });
    const jsonData = await data.json();
    const tickets = jsonData.tickets || {};
    if (ticketString.match(/[^a-zA-Z0-9]/)) {
      const errorCode = '';
      const errorType = 'invalid';
      const message = `Search value must be formatted as a ticket number, e.g. 'W111222333' or 'X123456789`;
      sendSumoLog(errorType, message, errorCode, dispatch);
      return {};
    } else if (!data.ok || Object.keys(tickets).length === 0) {
      const errorCode = data.status;
      const errorType = 'no results';
      const message = `No Matching Tickets`;
      sendSumoLog(errorType, message, errorCode, dispatch);
      return {};
    }
    return tickets;
  } catch (error) {
    const message = `fetch matching tickets ${ticketString} failed`;
    sendSumoLog(error, message, dispatch);
    return {};
  }
};
